import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/styles';

export const buttonVariants = cva(
  'uppercase inline-flex items-center font-general-sans-semibold justify-center not-italic	text-lg font-semibold border hover:bg-[#252525] hover:text-[#EEEDA8] hover:border-[#fffff0f0] focus:bg-[#252525] focus:text-[#EEEDA8] focus:border-[#fffff0f0]',
  {
    variants: {
      variant: {
        default: 'bg-[#FFFFF0] text-[#252525] border-[#252525]',
        defaultWhite: 'bg-[#FFFFFF] text-[#252525] border-[#252525]',
        secondary: 'bg-[#252525] text-[#EEEDA8] border-none',
      },
      size: {
        default: 'h-10 rounded-[30px]',
        sm: 'h-9 rounded-md',
        lg: 'h-11 rounded-md',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = 'Button';
